/**
 * HelpPanel — Expandable contextual help card
 *
 * Shows a "?" button that toggles an inline help card.
 * Used in both wizard and editor for section-level explanations.
 */

import React, { useState } from 'react';

export default function HelpPanel({ title, content, defaultOpen = false }) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="config-help-panel">
      <button
        type="button"
        className="config-help-toggle"
        onClick={() => setIsOpen(!isOpen)}
        title={isOpen ? 'Hide help' : 'Show help'}
        aria-expanded={isOpen}
      >
        ?
      </button>
      {isOpen && (
        <div className="config-help-content">
          {title && <div className="config-help-title">{title}</div>}
          <div className="config-help-text">{content}</div>
        </div>
      )}
    </div>
  );
}
